var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92291 15.8889C6.92291 18.0444 8.58961 19.7777 10.6341 19.7777H14.8118C16.5896 19.7777 18.034 18.2666 18.034 16.3777C18.034 14.3555 17.1452 13.6222 15.834 13.1555L9.14513 10.8222C7.83402 10.3555 6.94516 9.64442 6.94516 7.59998C6.94516 5.73331 8.38956 4.19998 10.1673 4.19998H14.3451C16.3896 4.19998 18.0563 5.93331 18.0563 8.08887M12.4785 2V22",
    stroke: "#111928",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.fe432ba38b548bb98e7190788f57b252.svg";
export { ForwardRef as ReactComponent };